/**
 * The product, moving. Two native players — no embed, no third-party
 * cookies — served from /media, web-sized copies built into the bundle.
 * `preload="none"`: a visitor who never presses play downloads the poster
 * and nothing else. Lit ground, so the stone ramp.
 */
const VIDEOS = [
  {
    id: "founder-pitch",
    eyebrow: "Founder pitch",
    title: "Why this exists, in 73 seconds",
    length: "1:13",
    blurb: "The problem, the bet, and what NextOpp will never do on your behalf.",
  },
  {
    id: "full-demo",
    eyebrow: "Full demo",
    title: "Search to submission, start to finish",
    length: "1:52",
    blurb: "Company boards, the match score, a truthful tailored resume, and the pipeline that keeps the search honest.",
  },
];

export default function ShowReel() {
  return (
    <section id="see-it" className="border-b border-sand bg-white snap-target" data-testid="showreel">
      <div className="max-w-7xl mx-auto px-6 py-16 lg:py-20">
        <div className="max-w-2xl">
          <div className="text-xs tracking-[0.2em] uppercase font-bold text-stone-600" data-testid="showreel-eyebrow">See it</div>
          <h2 className="mt-4 font-heading text-4xl lg:text-5xl font-bold tracking-tight text-stone-950">
            Two minutes, and you have seen the whole thing.
          </h2>
        </div>
        <div className="mt-10 grid lg:grid-cols-2 gap-8">
          {VIDEOS.map((v) => (
            <figure key={v.id} className="min-w-0">
              <div className="relative rounded-sm overflow-hidden border border-sand bg-stone-950 aspect-video">
                <video
                  className="absolute inset-0 w-full h-full"
                  controls
                  preload="none"
                  playsInline
                  poster={`/media/${v.id}.jpg`}
                  data-testid={`video-${v.id}`}
                >
                  <source src={`/media/${v.id}.mp4`} type="video/mp4" />
                  Your browser cannot play this video.{" "}
                  <a href={`/media/${v.id}.mp4`} className="underline">Download it</a> instead.
                </video>
              </div>
              <figcaption className="mt-4">
                <div className="flex items-center gap-3 text-xs tracking-[0.2em] uppercase font-bold text-stone-600">
                  <span>{v.eyebrow}</span>
                  <span className="font-mono tracking-normal normal-case font-medium text-stone-500">{v.length}</span>
                </div>
                <div className="mt-1 font-heading text-lg font-bold text-stone-950">{v.title}</div>
                <p className="mt-1 text-sm text-stone-600 leading-relaxed">{v.blurb}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
